export const PAYMENT_V2_STORE_ID = '50C99C99-FA3D-492D-B051-C5B7A2411DD4';

export function paymentV2StoreGateAllows(store) {
  const currency = typeof store?.currency === 'string'
    ? store.currency.trim().toUpperCase()
    : null;
  return (
    store?.id === PAYMENT_V2_STORE_ID &&
    store?.paymentSchemaVersion === 2 &&
    store?.catalogPriceSchemaVersion === 3 &&
    store?.paymentV2Enabled === true &&
    store?.isAcceptingOrders === true &&
    store?.holdPaymentUntilFulfilled === false &&
    currency === 'USD' &&
    Number.isSafeInteger(store?.taxRateBasisPoints) &&
    store.taxRateBasisPoints >= 0 &&
    store.taxRateBasisPoints <= 10_000
  );
}

/**
 * Read the authoritative store snapshot and return it only when the complete
 * payment-v2 contract is currently enabled.
 *
 * Callers must pass a server-source read (for example, getDocFromServer). A
 * cached Firestore snapshot must never be able to resume or begin payment.
 * Read failures intentionally propagate so the caller can fail closed with a
 * distinct "could not verify" message.
 */
export async function readAuthoritativePaymentV2Store(readStoreSnapshot) {
  if (typeof readStoreSnapshot !== 'function') return null;

  const snapshot = await readStoreSnapshot();
  if (
    !snapshot ||
    typeof snapshot.exists !== 'function' ||
    !snapshot.exists() ||
    typeof snapshot.data !== 'function'
  ) {
    return null;
  }

  const store = { id: snapshot.id, ...snapshot.data() };
  return paymentV2StoreGateAllows(store) ? store : null;
}
